import React from 'react';
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
} from '@material-ui/core';

export interface TableColumn {
  id: string;
  align?: 'left' | 'right' | 'center';
  label: string;
  renderer?: Function;
}

interface Props {
  columns: TableColumn[];
  rows: { [name: string]: any }[];
}

export const Table: React.FC<Props> = (props) => {
  const { columns, rows } = props;

  const getAlignment = (col: TableColumn, idx: number) =>
    idx === 0 ? 'left' : col.align || 'center';

  const renderTableCell = (col: TableColumn, value: any, idx: number) => (
    <TableCell key={col.id} align={getAlignment(col, idx)}>
      {col.renderer ? col.renderer(value) : value}
    </TableCell>
  );

  return (
    <TableContainer>
      <MuiTable aria-label="customized table">
        <TableHead>
          <TableRow>
            {columns.map((col, idx) => (
              <TableCell key={col.id} align={getAlignment(col, idx)}>
                {col.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, rIdx) => (
            <TableRow tabIndex={-1} key={rIdx}>
              {columns.map((col, idx) => {
                const value = row[col.id] as any;
                return renderTableCell(col, value, idx);
              })}
            </TableRow>
          ))}
        </TableBody>
      </MuiTable>
    </TableContainer>
  );
};
